import styled from 'styled-components';

export const AddReviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing[2]}px;

  width: 100%;

  max-width: 800px;

  margin: auto;

  padding: ${({ theme }) => theme.sizing[2]}px;

  > button {
    align-self: flex-end;

    min-width: 120px;
  }
`;

export const GroupedInput = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing[1]}px;

  > * {
    flex-grow: 1;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing[2]}px;

  h2 {
    font-family: ${({ theme }) => theme.core.fontFamily.jost};
    font-weight: ${({ theme }) => theme.core.fontWeight.medium};
    font-size: ${({ theme }) => theme.fontSizes.xxxl}px;

    margin: 0;
  }

  label {
    font-size: ${({ theme }) => theme.fontSizes.m}px;
    font-family: ${({ theme }) => theme.core.fontFamily.jost};
    font-weight: ${({ theme }) => theme.core.fontWeight.medium};

    textarea {
      background: transparent;

      border: 0.5px solid ${({ theme }) => theme.core.colors.greyscale.dark};

      border-radius: ${({ theme }) => theme.border.container.radius}px;
    }
  }

  label h3 {
    font-size: ${({ theme }) => theme.fontSizes.ml}px;

    color: ${({ theme }) => theme.core.colors.greyscale.dark};
    margin: 0;
  }

  @media ${({ theme }) => `${theme.breakpoints.m}`} {
    padding-top: 0;
  }
`;

export const FormButtons = styled.div`
  position: absolute;
  bottom: 0;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ theme }) => theme.sizing[1]}px;

  width: calc(100% - 2px);

  padding: ${({ theme }) => theme.sizing[2]}px;
  margin-right: -${({ theme }) => theme.sizing[2]}px;
  margin-left: -${({ theme }) => theme.sizing[2]}px;

  background: ${({ theme }) => theme.colors.greyscale.white};
`;

export const RatingContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing[0]}px;
  align-items: flex-start;
`;

export const RatingButton = styled.button`
  background: none;
  border: none;
`;
